const DocumentListRowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path
      d="M13.7242 4.14922L10.2742 0.749219C10.0742 0.549219 9.79922 0.449219 9.52422 0.449219L3.52422 0.449219C2.67422 0.449219 1.94922 1.14922 1.94922 2.02422L1.94922 14.0242C1.94922 14.8742 2.64922 15.5992 3.52422 15.5992L12.4492 15.5992C13.2992 15.5992 14.0242 14.8992 14.0242 14.0242L14.0242 4.89922C14.0242 4.62422 13.9242 4.34922 13.7242 4.14922ZM10.2992 2.34922L12.1742 4.19922L10.2992 4.19922V2.34922ZM12.4742 14.4492L3.52422 14.4492C3.27422 14.4492 3.07422 14.2492 3.07422 13.9992L3.07422 1.99922C3.07422 1.74922 3.27422 1.54922 3.52422 1.54922L9.17422 1.54922V4.74922C9.17422 5.04922 9.42422 5.32422 9.74922 5.32422L12.9242 5.32422L12.9242 13.9992C12.8992 14.2492 12.6992 14.4492 12.4742 14.4492Z"
      fill="#FBBF24"
    />
    <path
      d="M9.72422 7.27344L5.39922 7.27344C5.09922 7.27344 4.82422 7.52344 4.82422 7.84844C4.82422 8.17344 5.07422 8.42344 5.39922 8.42344H9.72422C10.0242 8.42344 10.2992 8.17344 10.2992 7.84844C10.2992 7.52344 10.0492 7.27344 9.72422 7.27344Z"
      fill="#FBBF24"
    />
    <path
      d="M9.72422 10.0234H5.39922C5.09922 10.0234 4.82422 10.2734 4.82422 10.5984C4.82422 10.9234 5.07422 11.1734 5.39922 11.1734H9.72422C10.0242 11.1734 10.2992 10.9234 10.2992 10.5984C10.2992 10.2734 10.0492 10.0234 9.72422 10.0234Z"
      fill="#FBBF24"
    />
  </svg>
);

export default DocumentListRowIcon;
